import { Locale } from 'src/types'

export const getTableHeaders = (locale: Locale['serviceContacts']) => {
  const { addServiceContacts: fieldsLocale } = locale

  return [
    fieldsLocale.contactName,
    fieldsLocale.phoneNumber,
    fieldsLocale.serviceType,
    fieldsLocale.address,
    fieldsLocale.additionalNotes,
  ]
}

export const getFavoriteTexts = (
  locale: Locale['serviceContacts'],
  isFavorite?: boolean,
) => {
  return isFavorite
    ? locale.historyServiceContacts.toast.favorite.added
    : locale.historyServiceContacts.toast.favorite.removed
}
